import type { Phrases } from '../Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { Span } from '../../../../components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	type PillShape,
	COMMON_FIELD_NAME,
	PILL_SHAPE,
} from '../constants';


export const PillShapeOtherTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const pillShape: PillShape = useWatch({ control, name: COMMON_FIELD_NAME.PILL_SHAPE}) as PillShape;
	const isOther = pillShape === PILL_SHAPE.OTHER;
	const pillShapeLabel = phrases['notificationForm.common.pillShapeField.label'];
	const label = phrases['notificationForm.common.pillShapeOtherField.label'];
	return (
		<TextField
			errorSummaryLabel={`${pillShapeLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={COMMON_FIELD_NAME.PILL_SHAPE_OTHER}
			showIf={({ watch }) => isOther}
		/>
	);
};
